import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import {
  ComingNomenclatureMaterial,
  ComingNomenclatureOptions,
  ComingNomenclatureTransportCreateRequest,
  ComingNomenclatureTransportDetail,
} from '../types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getComingNomenclatureOptions: builder.query<ComingNomenclatureOptions, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ComingNomenclature/${data.id}/options`,
      }),
      transformResponse: (response: ComingNomenclatureOptions) => {
        response.factories.sort((a, b) => a.id - b.id);
        return response;
      },
    }),
    getComingNomenclatureTransportDetail: builder.query<ComingNomenclatureTransportDetail, PayloadRequest>({
      query: ({ id }) => ({
        url: `/v1/ComingNomenclature/details/${id}`,
      }),
    }),
    comingNomenclatureTransportChange: builder.mutation<void, ComingNomenclatureTransportCreateRequest>({
      query: (data) => ({
        url: `/v1/ComingNomenclature/details/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    comingNomenclatureTransportDelete: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/ComingNomenclature/details/${data.id}`,
        method: 'DELETE',
        body: data,
      }),
    }),
    comingNomenclatureTransportCreate: builder.mutation<void, ComingNomenclatureTransportCreateRequest>({
      query: (data) => ({
        url: `/v1/ComingNomenclature/${data.comingId}/details`,
        method: 'POST',
        body: data,
      }),
    }),
    getComingNomenclatureMaterials: builder.query<ComingNomenclatureMaterial[], PayloadRequest>({
      query: ({ id }) => ({
        url: `/v1/ConsumptionNomenclature/material/${id}/units`,
      }),
    }),
  }),
});

export const {
  useLazyGetComingNomenclatureOptionsQuery,
  useGetComingNomenclatureOptionsQuery,
  useComingNomenclatureTransportChangeMutation,
  useComingNomenclatureTransportCreateMutation,
  useLazyGetComingNomenclatureTransportDetailQuery,
  useGetComingNomenclatureTransportDetailQuery,
  useLazyGetComingNomenclatureMaterialsQuery,
  useComingNomenclatureTransportDeleteMutation,
} = request;
